<template>
  <div class="spinner" :style="{ width: size + 'px', height: size + 'px' }">
    <svg
      id="eqhcjp6fnzp1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 304 304"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
    >
      <g id="eqhcjp6fnzp2">
        <g id="eqhcjp6fnzp3" transform="matrix(1 0 0 1 -34 -34)">
          <circle
            id="eqhcjp6fnzp4"
            r="146.500000"
            transform="matrix(0.26045430858251 0.75641493450408 -0.75641493450408 0.26045430858251 185.99999999964032 186.00000000212532)"
            fill="none"
            fill-rule="evenodd"
            stroke="rgb(247,247,247)"
            stroke-width="10"
            stroke-linecap="round"
          />
        </g>
      </g>
      <g
        id="eqhcjp6fnzp5"
        transform="matrix(0.56568542494924 0.56568542494924 -0.56568542494924 0.56568542494924 37.61439805970794 61.68043135401598)"
      >
        <g id="eqhcjp6fnzp6" transform="matrix(1 0 0 1 -53 -239)">
          <g
            id="eqhcjp6fnzp7_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp7"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              opacity="0"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(249,0,156)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp8_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp8"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              opacity="0"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(78,0,160)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp9_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp9"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              opacity="0"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(255,215,0)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp10_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp10"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              opacity="0"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(190,217,0)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp11_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp11"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              opacity="0"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(190,217,0)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp12_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp12"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              opacity="0"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(249,0,156)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp13_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp13"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(255,215,0)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp14_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp14"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(255,78,0)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
          <g
            id="eqhcjp6fnzp15_tr"
            transform="translate(232.873721,220.430229) rotate(71.000016)"
          >
            <path
              id="eqhcjp6fnzp15"
              d="M207.214206,353.714206C243.362404,353.714206,276.452762,340.622041,302.002226,318.920768C333.639565,292.048559,353.714206,251.975724,353.714206,207.214206C353.714206,126.304490,288.123922,60.714206,207.214206,60.714206C126.304490,60.714206,60.714206,126.304490,60.714206,207.214206C60.714206,237.178438,69.710103,265.041566,85.148469,288.250162C111.396930,327.709644,156.268722,353.714206,207.214206,353.714206Z"
              transform="scale(1,1) translate(-207.214206,-207.214206)"
              fill="none"
              fill-rule="evenodd"
              stroke="rgb(0,183,231)"
              stroke-width="30"
              stroke-linecap="round"
              stroke-dasharray="200 1000"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
/**
 * The spinner is for user feedback while page data is loading
 */
export default {
  name: 'NsSpinner',
  props: {
    /**
     * Size of the spinner in px
     */
    size: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style lang="scss">
#eqhcjp6fnzp7_tr {
  animation: eqhcjp6fnzp7_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp7_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  80% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.495, 0.49, 0.82, 0.11);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp7 {
  animation: eqhcjp6fnzp7_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp7_c_o {
  0% {
    opacity: 0;
  }
  77.500000% {
    opacity: 0;
  }
  80% {
    opacity: 1;
  }
  97.500000% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp8_tr {
  animation: eqhcjp6fnzp8_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp8_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  77.500000% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.1, 0.365, 0.82, 0.11);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp8 {
  animation: eqhcjp6fnzp8_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp8_c_o {
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  77.500000% {
    opacity: 1;
  }
  97.500000% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp9_tr {
  animation: eqhcjp6fnzp9_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp9_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  30% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.5, 0.495, 0.82, 0.11);
  }
  50% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp9 {
  animation: eqhcjp6fnzp9_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp9_c_o {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  27.500000% {
    opacity: 1;
  }
  47.500000% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp10_tr {
  animation: eqhcjp6fnzp10_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp10_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  27.500000% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.1, 0.365, 0.82, 0.11);
  }
  50% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp10 {
  animation: eqhcjp6fnzp10_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp10_c_o {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  27.500000% {
    opacity: 1;
  }
  47.500000% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp11_tr {
  animation: eqhcjp6fnzp11_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp11_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  55% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.495, 0.49, 0.82, 0.11);
  }
  75% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp11 {
  animation: eqhcjp6fnzp11_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp11_c_o {
  0% {
    opacity: 0;
  }
  52.500000% {
    opacity: 0;
  }
  55% {
    opacity: 1;
  }
  72.500000% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp12_tr {
  animation: eqhcjp6fnzp12_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp12_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  52.500000% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.1, 0.365, 0.82, 0.11);
  }
  75% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp12 {
  animation: eqhcjp6fnzp12_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp12_c_o {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  52.500000% {
    opacity: 1;
  }
  72.500000% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp13_tr {
  animation: eqhcjp6fnzp13_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp13_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  5% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.495, 0.49, 0.82, 0.11);
  }
  25% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp13 {
  animation: eqhcjp6fnzp13_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp13_c_o {
  0% {
    opacity: 1;
  }
  5% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  27.500000% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp14_tr {
  animation: eqhcjp6fnzp14_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp14_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
  }
  2.500000% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0.1, 0.365, 0.82, 0.11);
  }
  25% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
  }
}
#eqhcjp6fnzp14 {
  animation: eqhcjp6fnzp14_c_o 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp14_c_o {
  0% {
    opacity: 1;
  }
  2.500000% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  27.500000% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eqhcjp6fnzp15_tr {
  animation: eqhcjp6fnzp15_tr__tr 4000ms linear infinite normal forwards;
}
@keyframes eqhcjp6fnzp15_tr__tr {
  0% {
    transform: translate(232.873721px, 220.430229px) rotate(71.000016deg);
    animation-timing-function: cubic-bezier(0, 0.25, 0.795, 0.345);
  }
  25% {
    transform: translate(232.873721px, 220.430229px) rotate(430deg);
    animation-timing-function: cubic-bezier(0, 0.25, 0.795, 0.345);
  }
  50% {
    transform: translate(232.873721px, 220.430229px) rotate(791deg);
    animation-timing-function: cubic-bezier(0, 0.25, 0.795, 0.345);
  }
  75% {
    transform: translate(232.873721px, 220.430229px) rotate(1151deg);
    animation-timing-function: cubic-bezier(0, 0.25, 0.795, 0.345);
  }
  100% {
    transform: translate(232.873721px, 220.430229px) rotate(1511deg);
  }
}
</style>
